import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Form, Formik } from 'formik';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../store/reducers';
import { getHorse } from '../../../store/reducers/Stable/slice';
import Button from '../../Button/Button';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import ActivateHorse from './ActivateHorse/ActivateHorse';
import styles from './ActivateHorseModal.module.scss';
const ActivateHorseModal = ({ closeModal, asset }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const horse = useAppSelector((state) => state.stable.horse);
    useEffect(() => {
        dispatch(getHorse(asset));
    }, [dispatch, asset]);
    const stats = horse === null || horse === void 0 ? void 0 : horse.volatile.stats;
    const totalStats = useMemo(() => (stats ? Object.values(stats).reduce((curr, acc) => acc + curr, 0) : 0), [stats]);
    if (!horse)
        return _jsx(_Fragment, {});
    const horseData = {
        totalStats,
        speed: stats === null || stats === void 0 ? void 0 : stats.speed,
        stamina: stats === null || stats === void 0 ? void 0 : stats.stamina,
        acceleration: stats === null || stats === void 0 ? void 0 : stats.acceleration,
        endurance: stats === null || stats === void 0 ? void 0 : stats.endurance,
        agility: stats === null || stats === void 0 ? void 0 : stats.agility
    };
    return (_jsx("div", Object.assign({ className: styles.element }, { children: _jsxs(Modal, Object.assign({ className: styles.modal, background: true, closeModal: closeModal }, { children: [_jsx("div", Object.assign({ className: styles.title }, { children: _jsx(Heading, { title: t('activate_your_horse') }) })), _jsx(Formik, Object.assign({ initialValues: {
                        name: ''
                    }, onSubmit: (values) => {
                        // TODO: fix this horse modal so it activates the horse
                        // dispatch(activateHorse({id, name: values.name}))
                        closeModal();
                    } }, { children: ({ values, handleSubmit }) => (_jsx(Form, Object.assign({ onSubmit: handleSubmit }, { children: _jsxs("div", Object.assign({ className: cn(styles.box, 'd-flex flex-column') }, { children: [_jsx(ActivateHorse, { isModal: true, horseData: horseData, values: values }), _jsxs("div", Object.assign({ className: cn(styles.buttons, 'd-flex justify-content-between') }, { children: [_jsx(Button, { type: 'submit', color: 7, className: 'flex-1', text: t('save') }), _jsx(Button, { onClick: closeModal, color: 5, className: 'flex-1', text: t('cancel') }), _jsx(Button, { onClick: closeModal, color: 6, className: 'flex-1', text: t('skip_for_now') })] }))] })) }))) }))] })) })));
};
export default ActivateHorseModal;
